import React from 'react';
import { Key } from 'w3c-keys';
import { Button } from '../../button';
import { IconID } from '../../icon';
import styles from './pagination-items.module.scss';
export const PaginationItems = ({ batchOffset, batchSize, isNextDisabled, onBatchOffsetChange, children, }) => {
    const handleNextButtonClick = () => {
        if (onBatchOffsetChange && batchOffset && batchSize) {
            onBatchOffsetChange(batchOffset + batchSize);
        }
    };
    const handlePreviousButtonClick = () => {
        if (onBatchOffsetChange && batchOffset && batchSize) {
            onBatchOffsetChange(batchOffset - batchSize);
        }
    };
    return (React.createElement("nav", null,
        React.createElement("div", { className: styles.paginationList },
            children,
            React.createElement("div", { className: styles.paginationBlock },
                React.createElement(Button, { ariaLabel: "previous-button", type: "secondary", icon: IconID.CHEVRON_LEFT, size: "s", isDisabled: batchOffset === 1, className: "previousButton", "data-testid": "previous-button-pagination", onClick: handlePreviousButtonClick, onKeyDown: (e) => {
                        if (e.key === Key.Enter) {
                            e.stopPropagation();
                        }
                    } })),
            React.createElement("div", { className: styles.paginationBlock },
                React.createElement(Button, { ariaLabel: "next-button", type: "secondary", icon: IconID.CHEVRON_RIGHT, size: "s", isDisabled: isNextDisabled, className: "nextButton", "data-testid": "next-button-pagination", onClick: handleNextButtonClick, onKeyDown: (e) => {
                        if (e.key === Key.Enter) {
                            e.stopPropagation();
                        }
                    } })))));
};
//# sourceMappingURL=pagination-items.js.map